export default __webpack_public_path__ + "static/media/image-ph-study-main-1-n-m@3x.1e1bf6fd.webp";